import "whatwg-fetch"; // polyfill for older browsers

import {
  getAPIConfig,
  handleAPIResponse,
  convertQueryObjToString,
} from "@utils/browser-helpers";
import { executeAPIRequest } from "@adapters/api";

var DTPAdapter = {
  getDTPClients: async (query) => {
    let route = `/dtp_affected_clients${convertQueryObjToString(query)}`;
    const apiConfig = getAPIConfig(route, false, true);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
  getDTPDetails: async () => {
    let route = `/dtp_maintenance_windows`;
    const apiConfig = getAPIConfig(route, false, true);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
  getDTPHistory: async () => {
    let route = `/dtp_history`;
    const apiConfig = getAPIConfig(route, false, true);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
  getDTPTemplates: async () => {
    let route = `/dtp_draft`;
    const apiConfig = getAPIConfig(route, false, true);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
  createDTPSession: async (dtpDetails) => {
    let route = `/dtp_maintenance_windows`;
    const apiConfig = getAPIConfig(route, false, true);
    const response = await executeAPIRequest(
      apiConfig,
      "PUT",
      null,
      dtpDetails
    );
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
  activateDTPSession: async (dtpDetails) => {
    let route = `/dtp_maintenance_windows`;
    const apiConfig = getAPIConfig(route, false, true);
    const response = await executeAPIRequest(
      apiConfig,
      "POST",
      null,
      dtpDetails
    );
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
  saveDTPGroup: async (dtpDetails, method) => {
    let route = `/dtp_affected_clients${
      method === "DELETE" ? convertQueryObjToString(dtpDetails) : ""
    }`;
    const apiConfig = getAPIConfig(route, false, true);
    const response = await executeAPIRequest(
      apiConfig,
      method,
      null,
      dtpDetails
    );
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
  deleteTemplate: async (dtpDetails) => {
    let route = `/dtp_draft${convertQueryObjToString(dtpDetails)}`;
    const apiConfig = getAPIConfig(route, false, true);
    const response = await executeAPIRequest(apiConfig, "DELETE");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
};

window.DTPAdapter = DTPAdapter;

export default DTPAdapter;
